<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogAuditItem" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t('audititem_title')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="save">{{$t('save')}}</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md style="background-color: white;">
            <v-layout wrap>
              <v-flex xs12 sm6 md4 v-if="configuration.category">
                <v-autocomplete
                  @input="setCategory(editedItem.question.category)"
                  :items="currentCategories"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.question.category"
                  :label="$t('category_label')"
                  hint="Kategorisierung für diese Frage"
                  persistent-hint
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4 v-if="configuration.subcategory">
                <v-autocomplete
                  :items="currentSubcategories"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.question.subcategory"
                  :label="$t('subcategory_label')"
                  hint="Sub Kategorisierung für diese Frage"
                  persistent-hint
                  no-data-text="Keine Subkategorien vorhanden"
                >
                  <template slot="no-data">Keine Subkategorien vorhanden</template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4 v-if="configuration.chapters">
                <v-autocomplete
                  :items="currentChapters"
                  item-value="id"
                  v-model="editedItem.question.chapters"
                  :label="$t('chapters_label')"
                  chips
                  multiple
                  hint="Relevante Normkapitel für diese Frage"
                  persistent-hint
                  return-object
                >
                  <template
                    slot="item"
                    slot-scope="item"
                  >{{ item.item.id }} - {{ item.item.description }}</template>

                  <template slot="selection" slot-scope="item">
                    <v-chip>{{ item.item.id }} - {{ item.item.description }}</v-chip>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4 v-if="configuration.importance">
                <v-autocomplete
                  :items="importance"
                  item-value="id"
                  v-model="editedItem.question.importance"
                  :label="$t('importance_label')"
                  hint="Bedeutung dieses Kriteriums zum Bestehen des Audits"
                  persistent-hint
                >
                  <template
                    slot="item"
                    slot-scope="item"
                  >{{ item.item.id }} - {{ item.item.description }}</template>

                  <template
                    slot="selection"
                    slot-scope="item"
                  >{{ item.item.id }} - {{ item.item.description }}</template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4 v-if="configuration.processes">
                <v-autocomplete
                  :items="currentProcesses"
                  item-text="displayName"
                  item-value="displayName"
                  v-model="editedItem.processes"
                  :label="$t('processes_label')"
                  multiple
                  chips
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="configuration.question">
                <v-textarea
                  multi-line
                  v-model="editedItem.question.text"
                  :label="$t('audititem_label')"
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="configuration.hint">
                <v-textarea
                  multi-line
                  v-model="editedItem.question.hint"
                  :label="$t('audititem_hint_label')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">{{ $t('cancel') }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
{
  "de": {
    "audititem_title": "Audit-Frage",
    "audititem_label": "Audit-Frage",
    "audititem_hint_label": "Hinweis",
    "auditor_label": "Zugeordneter Auditor",
    "auditing_date_label": "Audit-Tag",
    "category_label": "Kategorie",
    "subcategory_label": "Unter-Kategorie",
    "chapters_label": "Zugeordnete Normkapitel",
    "importance_label": "Bedeutung",
    "processes_label": "Verlinkte Prozesse (Q.wiki)",
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "en": {
    "audititem_title": "Audit Question",
    "audititem_label": "Audit Question",
    "audititem_hint_label": "Hint",
    "auditor_label": "Auditor",
    "auditing_date_label": "Audit day",
    "category_label": "Category",
    "subcategory_label": "Subcategory",
    "chapters_label": "Assigned Standard Chapters",
    "importance_label": "Importance",
    "processes_label": "Linked processes (Q.wiki)",
    "cancel": "Cancel",
    "save": "Save"   
  }
}
</i18n>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import { api as standardsapi } from "@/store/modules/standards";
import { api as confApi } from "@/store/modules/configuration";
import { api } from "@/store/modules/templates";

export default {
  props: {
    dialogAuditItem: {
      default: {}
    }
  },
  data() {
    return {
      menu: false,
      today: null,
      currentCategory: ""
    };
  },
  computed: {
    ...mapGetters(standardsapi.namespace, [standardsapi.getters.getStandard]),
    ...mapGetters(confApi.namespace, [
      confApi.getters.audititem,
      confApi.getters.categories,
      confApi.getters.getCategory,
      confApi.getters.getSubcategory
    ]),
    ...mapGetters(api.namespace, [
      api.getters.getDialogItem,
      api.getters.getDialogAction,
      api.getters.getAuditId,
      api.getters.getAuditItemId,
      api.getters.loadedAudit
    ]),
    configuration() {
      return this.audititem.dialog || {};
    },
    importance() {
      return this.audititem.data.importance || {};
    },
    currentTemplate() {
      const template = this.loadedAudit(this.getAuditId);
      return template;
    },
    currentChapters() {
      // TODO: Möglichkeit bei mehreren zu auditierenden Standards schaffen
      console.log("Standard?", this.currentTemplate.standard);
      const standards = this.currentTemplate.standard || "iso9001";

      const standard = this.getStandard(standards);
      console.assert(
        typeof standard === "object",
        "Expect valid standard object. Found",
        standard,
        "for Id",
        this.currentTemplate.standard
      );
      console.log("Getting the Chapters", standard);
      let chapters = [];
      if (standard) {
        chapters = _.map(standard.chapters, chapter => {
          return { ...chapter, standard: standard.id };
        });
        console.log("Chapters", chapters);
      }

      return chapters;
    },
    // TODO: Kategorien und Subcategorien sind vermutlich eng mit dem genutzten Standard verbunden
    currentCategories() {
      //return this.audititem.data.categories || [];

      let standard = this.currentTemplate.standard || "default";
      console.log("Get Categories" + standard);

      // TODO: SMELL
      if (standard instanceof Array && standard.length) {
        standard = standard[0];
      }

      console.log(this.getCategory(standard));

      return this.getCategory(standard.toLowerCase()) || [];
    },
    currentSubcategories() {
      if (this.currentCategory) {
        let category = this.currentCategories.find(category => {
          return category.id === this.currentCategory;
        });

        return category.subcategories || [];
      } else {
        return [];
      }
    },
    editedItem() {
      return this.getDialogItem;
    },
    isUpdate() {
      if (this.getDialogAction === "update") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.createAuditItem,
      api.actions.updateAuditItem
    ]),
    setCategory(val) {
      this.currentCategory = val || "";
    },
    close() {
      this.$emit("update:dialogAuditItem", false);
    },
    save() {
      if (this.isUpdate) {
        console.log("Updating Audit-Item");
        const audit_item = { ...this.editedItem };

        const payload = {
          audit_id: this.getAuditId,
          audititem_id: this.getAuditItemId,
          data: audit_item
        };

        this.updateAuditItem(payload);
      } else {
        console.log("Creating new Audit-Item");
        const audit_item = [{ ...this.editedItem }];

        const payload = {
          audit_id: this.getAuditId,
          data: audit_item
        };

        this.createAuditItem(payload);
      }

      this.close();
    }
  }
};
</script>
